
import { useState, useEffect } from "react";
import "../styles/Home.css";


function Home() {
  const diasSemana = ["DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO"];
  const hoy = diasSemana[new Date().getDay()];
  const [dias, setDias] = useState([]);
  const [frase, setFrase] = useState("");
  const BASE_URL = "https://streamer.tutorandy.xyz/php"
  useEffect(() => {
    fetch(`${BASE_URL}/eventos.php`)
      .then((res) => res.json())
      .then((data) => setDias(data))
      .catch((err) => console.error("Error cargando eventos", err));
  }, [BASE_URL]);

  useEffect(() => {
    fetch(`${BASE_URL}/frase.php`)
      .then(res => res.json())
      .then(data => setFrase(data.frase))
      .catch(err => console.error("Error cargando frase", err));
  }, [BASE_URL]);

  return (
    <main className="home-container">
      <h1>ITINERARIO SEMANAL de tu familia Pretty Woman</h1>
      {frase && (
        <p className="frase">
          {frase}
        </p>
      )}
      <p className="intro">
        Recuerda que por ser parte de la <strong>@familiaprettywoman</strong> cuentas con clases de inglés y conferencias psicológicas.
      </p>

      <p className="hoy-texto">📅 Hoy es <strong>{hoy}</strong> — Solo las actividades del día están activas</p>

      <section className="calendario">
        {dias.map((dia, i) => (
          <div className="tarjeta-dia" key={i}>
            <h2>{dia.dia}</h2>
            {dia.eventos.map((evento, j) => (
              <div className="evento" key={j}>
                <p><strong>{evento.hora}</strong> - {evento.titulo}</p>
                {evento.tema && <p><em>{evento.tema}</em></p>}
                {evento.plataforma && <p>Plataforma: {evento.plataforma}</p>}
                {dia.dia === hoy ? (
                  <a href={evento.link} target="_blank" rel="noopener noreferrer" className="boton-link">Unirse</a>
                ) : (
                  <button className="boton-link disabled" disabled>No disponible hoy</button>
                )}
              </div>
            ))}
          </div>
        ))}
      </section>
    </main>
  );
}

export default Home;
